// https://vuex.vuejs.org/en/modules.html

const requireModule = require.context('.', true, /\.js$/);
const modules = {};

requireModule.keys().forEach((fileName) => {
  const isIndexFile = fileName === './index.js';
  const isTestFile = fileName.includes('/__tests__/') || fileName.endsWith('.spec.js') || fileName.endsWith('.test.js');

  if (isIndexFile || isTestFile) {
    return;
  }

  // Replace ./ and .js
  const path = fileName.replace(/(\.\/|\.js)/g, '');
  const [moduleName, imported] = path.split('/');

  if (!modules[moduleName]) {
    modules[moduleName] = {
      namespaced: true,
    };
  }

  modules[moduleName][imported] = requireModule(fileName).default;
});

export default modules;
